import {
  labelXXSmall
} from "./chunk.GAOIIZQS.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/password-validator-rule/password-validator-rule.styles.ts
var password_validator_rule_styles_default = r` ${component_styles_default} :host { display: block; margin: var(--sl-spacing-2x-small) 0; } .password-rule { display: flex; flex-direction: row; align-items: center; } .password-rule__icons { display: flex; align-items: start; } .password-rule__icon { font-size: 13px; } .password-rule__label { flex: 1; display: flex; margin-left: var(--sl-spacing-x-small); color: var(--sl-input-help-text-color); ${labelXXSmall} font-weight: var(--sl-font-weight-semibold); } `;

export {
  password_validator_rule_styles_default
};
